<script>
import { HorizontalBar } from "vue-chartjs";

// import ChartDataLabels from "chartjs-plugin-datalabels";

// Chart.plugins.unregister(ChartDataLabels);
// Chart.helpers.merge(Chart.defaults.global.plugins.datalabels, {
//   color: "#FFF",
// });

export default {
  extends: HorizontalBar,
  props: ["data", "options", "refresh"],
  data() {
    return {
      defaultData: {
        labels: ["UNKNOWN"],
        datasets: [
          // {
          //   backgroundColor: ["#007bff", "#28a745", "#ffc107", "#dc3545"],
          //   data: [40],
          // },
        ],
      },
      defaultOptions: {
        options: {
          responsive: true,
          maintainAspectRatio: false,
          datalabels: {
            display: false,
          },
          tooltips: {
            enabled: false,
          },
          // hover: {
          //   animationDuration: 0,
          // },
          scales: {
            xAxes: [
              {
                ticks: {
                  beginAtZero: true,
                  fontFamily: "'Open Sans Bold', sans-serif",
                  fontSize: 11,
                },
                scaleLabel: {
                  display: false,
                },
                gridLines: {},
                stacked: true,
              },
            ],
            yAxes: [
              {
                gridLines: {
                  display: false,
                  color: "#fff",
                  zeroLineColor: "#fff",
                  zeroLineWidth: 0,
                },
                ticks: {
                  fontFamily: "'Open Sans Bold', sans-serif",
                  fontSize: 11,
                },
                stacked: true,
              },
            ],
          },
        },
        onClick: function (evt, item) {
          var activePoints = this.getElementsAtEvent(evt);
          var firstPoint = activePoints[0];
          console.log("bar click", evt, item, activePoints, firstPoint);
        },
      },
      chartData: null,
      chartOptions: null,
    };
  },
  mounted() {
    this.render();
  },
  watch: {
    data: {
      // immediate: true,
      handler(newVal, oldVal) {
        if (newVal) {
          this.render();
        }
      },
    },
  },
  methods: {
    async render() {
      if (this.data) {
        this.chartData = this.data;
      } else {
        this.chartData = this.defaultData;
      }
      if (this.options) {
        this.chartOptions = this.options;
      } else {
        this.chartOptions = this.defaultOptions;
      }
      // // if (this.chartOptions.datalabels.display == true) {
      //   this.addPlugin(ChartDataLabels);
      // // }

      this.renderChart(this.chartData, this.chartOptions);
    },
  },
};
</script>